<script>

export default {
  name: 'AdBox',
  props: {
    banners: {
      required: true,
    },
  },
  computed: {
    gridStyle () {
      const makeGrid = (length) =>
        length === 1 ? ['full', 'full'] : ['half-top', 'half-bottom'];
      const grid = makeGrid(this.banners.length);
      return {
        display: 'grid',
        gridTemplateAreas: `
          "${grid[0]}"
          "${grid[1]}"
        `,
      };
    },
  },
  methods: {
    getGridArea ({ size, side, position }) {
      return [size, position].filter(v => !!v).join('-');
    },
  },
};
</script>

<template lang="pug">
  div.ad-box(:style="gridStyle")
    div.adimg.contain.bg-center(v-for="({ imageUrl, size, side, position }) in banners", :style="{ gridArea: getGridArea({ size, side, position}), backgroundImage: `url(${imageUrl})` }")
      //- img.adimg(:src="imageUrl")
      //- img.adimg(v-for="({ imageUrl, size, side, position }) in banners", :style="{ gridArea: getGridArea({ size, side, position}) }", :src="imageUrl")

</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.ad-box {
  grid-gap: 2rem;
}
</style>
